import { createFileRoute } from "@tanstack/react-router";
import { ExtratosBancariosPage } from "@/pages/ExtratosBancariosPage";

export const Route = createFileRoute("/extratos-bancarios/")({
  head: () => ({
    meta: [
      { title: "Extratos Bancários — AXIS Comprovantes" },
      { name: "description", content: "Lista de extratos bancários importados." },
    ],
  }),
  component: ExtratosBancariosPage,
});
